"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoadState;
(function (LoadState) {
    LoadState[LoadState["OptionsNotLoaded"] = 0] = "OptionsNotLoaded";
    LoadState[LoadState["OptionsLoading"] = 1] = "OptionsLoading";
    LoadState[LoadState["OptionsLoaded"] = 2] = "OptionsLoaded";
})(LoadState = exports.LoadState || (exports.LoadState = {}));
//# sourceMappingURL=OwsOptionsStore.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-outlook-service-options/lib/store/schema/OwsOptionsStore.js
// module id = 2128
// module chunks = 2 3 4 39 49 108